import styled from "styled-components";
import { TabPanel } from "discover.medical.react-component-library";

export const OptionGridTabPanel = styled(TabPanel)`
  padding-top: ${({ theme }) => theme.space.md};
`;
